angular.module( 'acme.view.application.entities.templates', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.card',
  'acme.view.application.entities.templates.create',
  'acme.view.application.entities.templates.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var entitiesTemplates = {
        name: 'application.entities.templates',
        url: '/templates/:type',
        views: {
          "subview-main": {
            controller: 'EntitiesTemplatesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/entities/templates/templates.tpl.html'
          }
        },
        resolve: {
          preferenceKey: ['$state', '$stateParams', function($state, $stateParams) {
            var preferenceKey = $stateParams.type;

            // when refreshing the browser data is not set
            $state.$current.data = $state.$current.data || {};
            $state.$current.data.preferenceKey = preferenceKey;
            return preferenceKey;
          }]
        },
        data: {
          pageTitle: '  ',
          enablePreferences: true
        }
      };

    $stateProvider
      .state(entitiesTemplates);
});
